/**
 * Утилиты для работы с доменами на фронте
 */

/**
 * Получить текущий домен
 * @returns {string} Текущий домен
 */
export const getCurrentDomain = () => {
    return window.location.hostname.toLowerCase();
};

/**
 * Проверить, является ли домен operativno
 * @param {string} domain - домен для проверки
 * @returns {boolean} true если домен operativno
 */
export const isOperativnoDomain = (domain = null) => {
    const currentDomain = domain || getCurrentDomain();
    return currentDomain.includes("allnews");
};

/**
 * Определить, нужно ли показывать главное лого
 * @param {string} domain - домен для проверки
 * @returns {boolean} true если нужно показать главное лого
 */
export const shouldShowMainLogo = (domain = null) => {
    return !isOperativnoDomain(domain);
};
